<template>
    <div class="col-12 message-wrapper">
        <slot />
    </div>
</template>

<style lang="scss" scoped>
.message-wrapper {
    cursor: pointer;
    color: #808080;
    font-size: 15px;
    text-align: center;
}
</style>
